import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Only super_admin can access these routes.
export default function SuperAdminOnly({ children }) {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role !== "super_admin") return <Navigate to="/dashboard" replace/>;
  return children;
}
